export function debounce<T extends (...args: unknown[]) => void>(func: T, wait: number): (...args: Parameters<T>) => void {
	let timeout: ReturnType<typeof setTimeout>;

	return function executedFunction(...args: Parameters<T>): void {
		const later = () => {
			clearTimeout(timeout);
			func(...args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

/**
 * Creates a gate that resolves only when no further call comes in within `wait` ms.
 * Superseded calls never resolve, so whatever is chained behind them is skipped.
 *
 * Used to throttle Algolia requests while the user is still typing: the search is
 * only issued once typing pauses, instead of once per keystroke.
 */
export function createDebounceGate(wait: number): () => Promise<void> {
	let timeout: ReturnType<typeof setTimeout> | undefined;

	return function gate(): Promise<void> {
		clearTimeout(timeout);

		return new Promise<void>((resolve) => {
			timeout = setTimeout(resolve, wait);
		});
	};
}
